import i18n from '@/utils/i18n'
import { PROVIDER_NAME_PAIRS_KO } from '@/data/providerNames.ko'

/** 영문 비교용 키 (공백·특수문자 제거, 소문자) */
export function normalizeProviderNameKey (name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\([^)]*\)/g, '')
    .replace(/[^a-z0-9]/g, '')
}

function buildKoLookup () {
  const map = Object.create(null)
  PROVIDER_NAME_PAIRS_KO.forEach(([english, korean]) => {
    const key = normalizeProviderNameKey(english)
    if (key) map[key] = korean
    const trimmed = String(english || '').trim()
    if (trimmed) map[trimmed.toLowerCase()] = korean
  })
  return map
}

const KO_LOOKUP = buildKoLookup()

export function getActiveLocale () {
  return (i18n && i18n.locale) ? String(i18n.locale).toLowerCase() : 'ko'
}

/**
 * 게임사 표시명 — locale이 ko이면 한국어 매핑, 아니면 API name 그대로
 */
export function localizeProviderDisplayName (name, locale = getActiveLocale()) {
  const raw = String(name || '').trim()
  if (!raw) return raw
  if (String(locale).toLowerCase() !== 'ko') return raw

  const key = normalizeProviderNameKey(raw)
  if (key && KO_LOOKUP[key]) return KO_LOOKUP[key]

  const lower = raw.toLowerCase()
  if (KO_LOOKUP[lower]) return KO_LOOKUP[lower]

  // i18n provider.* 키 (추가 등록 시 자동 반영)
  if (i18n && typeof i18n.te === 'function') {
    const i18nKey = `provider.${key}`
    const translated = i18n.te(i18nKey)
    if (translated && translated !== i18nKey) return translated
  }

  return raw
}
